const popupActionTypes = {
    CLEAR_POPUP_TEXT: 'CLEAR_POPUP_TEXT',
};

export default popupActionTypes;
